import { render, staticRenderFns } from "./ProductsGroup.vue?vue&type=template&id=bed041f8"
import script from "./ProductsGroup.vue?vue&type=script&lang=js"
export * from "./ProductsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports